// Hook de acesso ao ThemeContext. Erro claro se usado fora do provider —
// não temos default silencioso pra evitar comportamento "fantasma".
import { useContext } from 'react';
import { ThemeContext, type ThemeContextValue } from './ThemeProvider';

export function useTheme(): ThemeContextValue {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useTheme deve ser usado dentro de <ThemeProvider>.');
  }
  return ctx;
}
